export interface Movie {
  id: string;
  title: string;
  subtitle: string;
  category: string;
  genres: string[];
  year: number;
  rating: number;
  description: string;
  director: string;
  actors: string[];
  region: string;
  duration: string;
  updateDate: string;
  coverImage: string;
  posterImage: string;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
}

export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-rocket-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line' },
];

export const movies: Movie[] = [
  {
    id: '1',
    title: '长安三万里',
    subtitle: 'Chang An',
    category: 'movie',
    genres: ['动画', '历史', '剧情'],
    year: 2023,
    rating: 9.2,
    description: '安史之乱爆发后数年，吐蕃大军攻打西南。大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事。影片以盛唐为背景，讲述安史之乱后，整个长安因战争而陷入混乱，身处局势之中的高适回忆起自己与李白的过往。',
    director: '谢君伟 / 邹靖',
    actors: ['杨天翔', '凌振赫', '吴俊全', '宣晓鸣'],
    region: '中国大陆',
    duration: '168分钟',
    updateDate: '2024-07-15',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20animated%20film%20scene%20featuring%20ancient%20Tang%20Dynasty%20Changan%20cityscape%20at%20sunset%20with%20warm%20golden%20light%2C%20traditional%20Chinese%20architecture%2C%20poetic%20atmosphere%2C%20cinematic%20composition%2C%20soft%20painterly%20style&width=800&height=450&seq=movie-cover-1&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20movie%20poster%20style%20featuring%20Tang%20Dynasty%20poets%20Li%20Bai%20and%20Gao%20Shi%20in%20traditional%20robes%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20crimson%20tones%2C%20Chinese%20calligraphy%20title%2C%20epic%20cinematic%20poster%20design&width=600&height=800&seq=movie-poster-1&orientation=portrait',
    isHot: true,
    isNew: false,
    tags: ['热播', '高分', '动画'],
  },
  {
    id: '2',
    title: '流浪地球3',
    subtitle: 'The Wandering Earth III',
    category: 'movie',
    genres: ['科幻', '冒险', '灾难'],
    year: 2024,
    rating: 8.9,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    region: '中国大陆',
    duration: '173分钟',
    updateDate: '2024-08-01',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20scene%20with%20massive%20planet%20engines%20propelling%20Earth%20through%20deep%20space%2C%20nebula%20colors%20in%20background%2C%20epic%20scale%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20cool%20blue%20and%20orange%20contrast&width=800&height=450&seq=movie-cover-2&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20blockbuster%20movie%20poster%2C%20Earth%20with%20giant%20engines%20in%20deep%20space%2C%20astronauts%20silhouette%2C%20dramatic%20orange%20and%20blue%20lighting%2C%20epic%20scale%2C%20cinematic%20poster%20design%20with%20Chinese%20title&width=600&height=800&seq=movie-poster-2&orientation=portrait',
    isHot: true,
    isNew: true,
    tags: ['热播', '新片', '科幻'],
  },
  {
    id: '3',
    title: '热辣滚烫',
    subtitle: 'YOLO',
    category: 'movie',
    genres: ['剧情', '喜剧', '运动'],
    year: 2024,
    rating: 8.5,
    description: '乐莹是一个善良的女孩，却总是被身边人利用和伤害。在经历了种种挫折后，她偶然接触到了拳击这项运动，并在拳击的世界里找到了自我价值和人生的方向，完成了一次惊艳的蜕变。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    region: '中国大陆',
    duration: '129分钟',
    updateDate: '2024-06-20',
    coverImage: 'https://readdy.ai/api/search-image?query=Boxing%20ring%20scene%20with%20warm%20dramatic%20lighting%2C%20female%20boxer%20training%20intensely%2C%20sweat%20and%20determination%2C%20motivational%20atmosphere%2C%20cinematic%20composition%2C%20warm%20golden%20tones&width=800&height=450&seq=movie-cover-3&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%2C%20female%20boxer%20with%20boxing%20gloves%2C%20determined%20expression%2C%20warm%20lighting%2C%20inspirational%20theme%2C%20red%20and%20gold%20color%20scheme%2C%20cinematic%20poster&width=600&height=800&seq=movie-poster-3&orientation=portrait',
    isHot: true,
    isNew: false,
    tags: ['热播', '励志', '喜剧'],
  },
  {
    id: '4',
    title: '封神第二部',
    subtitle: 'Creation of the Gods II',
    category: 'movie',
    genres: ['奇幻', '动作', '古装'],
    year: 2024,
    rating: 8.7,
    description: '殷商末年，纣王暴虐无道。姬发在姜子牙的辅佐下，率领西岐军民奋起反抗。封神大战全面爆发，仙魔人三界风云变幻，一场关乎天下苍生命运的史诗对决拉开帷幕。',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适', '陈牧驰'],
    region: '中国大陆',
    duration: '150分钟',
    updateDate: '2024-07-28',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20battle%20scene%20with%20ancient%20warriors%20in%20armor%2C%20mythical%20creatures%2C%20dramatic%20stormy%20sky%2C%20large-scale%20war%2C%20cinematic%20lighting%2C%20dark%20and%20golden%20tones&width=800&height=450&seq=movie-cover-4&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20movie%20poster%2C%20ancient%20gods%20and%20warriors%2C%20mythological%20creatures%2C%20dramatic%20composition%2C%20gold%20and%20crimson%20color%20scheme%2C%20cinematic%20poster%20design&width=600&height=800&seq=movie-poster-4&orientation=portrait',
    isHot: true,
    isNew: true,
    tags: ['热播', '新片', '奇幻'],
  },
  {
    id: '5',
    title: '庆余年第二季',
    subtitle: 'Joy of Life Season 2',
    category: 'tv',
    genres: ['古装', '剧情', '权谋'],
    year: 2024,
    rating: 9.4,
    description: '范闲在经历了第一季的生死考验后，继续在南庆朝廷中周旋。面对更加复杂的权谋斗争和身世之谜，范闲将如何在各方势力中保全自身，又能否揭开隐藏在背后的惊天秘密？',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    region: '中国大陆',
    duration: '36集',
    updateDate: '2024-07-30',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20scene%20with%20intricate%20wooden%20architecture%2C%20court%20officials%20in%20traditional%20robes%2C%20dramatic%20lighting%20through%20lattice%20windows%2C%20mysterious%20atmosphere%2C%20warm%20amber%20tones&width=800&height=450&seq=movie-cover-5&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%2C%20young%20scholar%20in%20traditional%20robes%2C%20ancient%20palace%20background%2C%20ink%20wash%20painting%20style%2C%20elegant%20composition%2C%20warm%20brown%20and%20gold%20tones&width=600&height=800&seq=movie-poster-5&orientation=portrait',
    isHot: true,
    isNew: true,
    tags: ['热播', '新剧', '高分'],
  },
  {
    id: '6',
    title: '繁花',
    subtitle: 'Blossoms Shanghai',
    category: 'tv',
    genres: ['剧情', '爱情', '都市'],
    year: 2024,
    rating: 9.1,
    description: '九十年代的上海，处处是机遇与挑战。阿宝凭借自己的智慧和努力，在商海中浮沉打拼，从默默无闻的小人物成长为叱咤风云的宝总。而在他的身边，还有玲子、汪小姐和李李这三位与他命运交织的女性。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    region: '中国大陆',
    duration: '30集',
    updateDate: '2024-07-25',
    coverImage: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20at%20night%20with%20neon%20lights%2C%20vintage%20cars%2C%20elegant%20people%20in%20period%20clothing%2C%20rain%20on%20pavement%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20light%2C%20cinematic%20composition&width=800&height=450&seq=movie-cover-6&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%2C%201990s%20Shanghai%20nostalgia%2C%20elegant%20man%20in%20suit%2C%20neon%20lights%20background%2C%20romantic%20atmosphere%2C%20warm%20golden%20tones%2C%20cinematic%20poster&width=600&height=800&seq=movie-poster-6&orientation=portrait',
    isHot: true,
    isNew: false,
    tags: ['热播', '高分', '经典'],
  },
  {
    id: '7',
    title: '奔跑吧第八季',
    subtitle: 'Keep Running S8',
    category: 'variety',
    genres: ['真人秀', '综艺', '竞技'],
    year: 2024,
    rating: 8.3,
    description: '全新一季奔跑吧重磅回归！常驻嘉宾阵容全面升级，更有飞行嘉宾惊喜加盟。经典游戏环节全面革新，全新挑战更加刺激有趣，带你感受不一样的奔跑体验。',
    director: '姚译添',
    actors: ['李晨', '郑恺', '杨颖', '白鹿', '周深'],
    region: '中国大陆',
    duration: '12期',
    updateDate: '2024-07-31',
    coverImage: 'https://readdy.ai/api/search-image?query=Colorful%20outdoor%20variety%20show%20scene%20with%20group%20of%20celebrities%20running%20and%20laughing%2C%20bright%20sunlight%2C%20green%20grass%20field%2C%20energetic%20atmosphere%2C%20vibrant%20colors%2C%20fun%20and%20dynamic%20composition&width=800&height=450&seq=movie-cover-7&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20celebrities%20in%20colorful%20sportswear%2C%20energetic%20poses%2C%20bright%20and%20cheerful%20atmosphere%2C%20vibrant%20color%20scheme%2C%20fun%20poster%20design&width=600&height=800&seq=movie-poster-7&orientation=portrait',
    isHot: true,
    isNew: true,
    tags: ['热播', '综艺', '新季'],
  },
  {
    id: '8',
    title: '鬼灭之刃 柱训练篇',
    subtitle: 'Demon Slayer: Hashira Training Arc',
    category: 'anime',
    genres: ['动画', '动作', '奇幻'],
    year: 2024,
    rating: 9.3,
    description: '炭治郎一行人在锻刀村之战后，为了更好地对抗鬼舞辻无惨，开始了由各位柱亲自指导的严酷训练。面对前所未有的试炼，少年们能否突破极限，获得与上弦之鬼一战的实力？',
    director: '外崎春雄',
    actors: ['花江夏树', '鬼头明里', '下野纮', '松冈祯丞'],
    region: '日本',
    duration: '8集',
    updateDate: '2024-08-01',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20scene%20with%20samurai%20training%20in%20traditional%20dojo%2C%20cherry%20blossoms%20falling%2C%20dynamic%20action%20pose%2C%20vibrant%20colors%2C%20anime%20aesthetic%2C%20dramatic%20lighting&width=800&height=450&seq=movie-cover-8&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20style%2C%20demon%20slayer%20character%20with%20katana%2C%20water%20breathing%20effect%2C%20dynamic%20composition%2C%20vibrant%20blue%20and%20red%20colors%2C%20anime%20poster%20design&width=600&height=800&seq=movie-poster-8&orientation=portrait',
    isHot: true,
    isNew: false,
    tags: ['热播', '日漫', '高分'],
  },
  {
    id: '9',
    title: '奥本海默',
    subtitle: 'Oppenheimer',
    category: 'movie',
    genres: ['传记', '历史', '剧情'],
    year: 2023,
    rating: 8.8,
    description: '影片聚焦"原子弹之父"罗伯特·奥本海默的故事。观众将看到一个谜一般的男人是如何陷入一个自相矛盾的困境：他为了拯救这个世界，必须先毁灭它。讲述了美国"原子弹之父"奥本海默开发原子弹的故事。',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    region: '美国',
    duration: '180分钟',
    updateDate: '2024-05-10',
    coverImage: 'https://readdy.ai/api/search-image?query=Dramatic%20black%20and%20white%20cinematic%20scene%20with%20nuclear%20explosion%20mushroom%20cloud%20in%20desert%2C%20intense%20orange%20fire%2C%20silhouette%20of%20man%20watching%2C%20apocalyptic%20atmosphere%2C%20cinematic%20composition&width=800&height=450&seq=movie-cover-9&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Hollywood%20biographical%20movie%20poster%2C%20intense%20portrait%20of%20scientist%2C%20nuclear%20explosion%20background%2C%20dramatic%20orange%20and%20black%20contrast%2C%20cinematic%20poster%20design&width=600&height=800&seq=movie-poster-9&orientation=portrait',
    isHot: false,
    isNew: false,
    tags: ['经典', '传记', '高分'],
  },
  {
    id: '10',
    title: '熊出没·逆转时空',
    subtitle: 'Boonie Bears: Time Twist',
    category: 'movie',
    genres: ['动画', '喜剧', '冒险'],
    year: 2024,
    rating: 8.4,
    description: '光头强与熊大熊二意外穿越时空，来到了一个完全陌生的未来世界。在这个充满高科技的世界里，他们必须团结一致，找到回到原来的方法，同时还要阻止一场可能改变历史的阴谋。',
    director: '林汇达',
    actors: ['谭笑', '张伟', '张秉君'],
    region: '中国大陆',
    duration: '99分钟',
    updateDate: '2024-07-20',
    coverImage: 'https://readdy.ai/api/search-image?query=Colorful%203D%20animated%20scene%20with%20bears%20and%20human%20character%20in%20futuristic%20city%2C%20time%20travel%20portal%20effect%2C%20bright%20and%20cheerful%20colors%2C%20family-friendly%20atmosphere%2C%20animated%20film%20style&width=800&height=450&seq=movie-cover-10&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%203D%20animated%20family%20movie%20poster%2C%20two%20bears%20and%20a%20man%20in%20futuristic%20setting%2C%20colorful%20and%20playful%20design%2C%20time%20travel%20theme%2C%20bright%20colors%2C%20children%20movie%20poster&width=600&height=800&seq=movie-poster-10&orientation=portrait',
    isHot: false,
    isNew: true,
    tags: ['新片', '动画', '合家欢'],
  },
  {
    id: '11',
    title: '长相思第二季',
    subtitle: 'Lost You Forever S2',
    category: 'tv',
    genres: ['古装', '爱情', '奇幻'],
    year: 2024,
    rating: 8.6,
    description: '小夭在经历第一季的种种磨难后，她的真实身份逐渐浮出水面。面对涂山璟、相柳和玱玹三位与她命运交织的男子，小夭将如何在爱情与责任之间做出选择？上古神话背景下的虐恋故事持续上演。',
    director: '秦榛 / 杨欢',
    actors: ['杨紫', '张晚意', '邓为', '檀健次'],
    region: '中国大陆',
    duration: '30集',
    updateDate: '2024-07-29',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20romance%20scene%20with%20beautiful%20characters%20in%20flowing%2C%20ethereal%20robes%2C%20moonlit%20garden%20with%20cherry%20blossoms%2C%20dreamy%20atmosphere%2C%20soft%20warm%20lighting%2C%20romantic%20composition&width=800&height=450&seq=movie-cover-11&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20TV%20drama%20poster%2C%20beautiful%20couple%20in%20ancient%20Chinese%20costumes%2C%20ethereal%20and%20dreamy%20atmosphere%2C%20soft%20pink%20and%20gold%20tones%2C%20romantic%20poster%20design&width=600&height=800&seq=movie-poster-11&orientation=portrait',
    isHot: true,
    isNew: true,
    tags: ['热播', '新剧', '古装'],
  },
  {
    id: '12',
    title: '歌手2024',
    subtitle: 'Singer 2024',
    category: 'variety',
    genres: ['音乐', '综艺', '竞演'],
    year: 2024,
    rating: 8.9,
    description: '华语乐坛顶级音乐竞演节目重磅回归！本季采用全新直播形式，国内外实力唱将同台竞技，用最真实的歌声征服观众。每一期都是一场视听盛宴，每一首歌都是一次心灵的震撼。',
    director: '洪涛',
    actors: ['那英', '汪苏泷', '杨丞琳', 'Faouzia'],
    region: '中国大陆',
    duration: '12期',
    updateDate: '2024-07-26',
    coverImage: 'https://readdy.ai/api/search-image?query=Grand%20music%20stage%20with%20dramatic%20stage%20lighting%2C%20singer%20performing%20on%20large%20stage%2C%20spotlight%20effect%2C%20concert%20atmosphere%2C%20colorful%20light%20beams%2C%20professional%20production%20design&width=800&height=450&seq=movie-cover-12&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%2C%20singer%20with%20microphone%20on%20stage%2C%20dramatic%20spotlight%2C%20golden%20and%20black%20color%20scheme%2C%20elegant%20and%20powerful%20design&width=600&height=800&seq=movie-poster-12&orientation=portrait',
    isHot: true,
    isNew: false,
    tags: ['热播', '音乐', '直播'],
  },
  {
    id: '13',
    title: '蓝色监狱',
    subtitle: 'Blue Lock',
    category: 'anime',
    genres: ['动画', '运动', '竞技'],
    year: 2024,
    rating: 8.7,
    description: '为了培养出能带领日本队夺得世界杯的绝对王牌前锋，日本足协启动了一个疯狂的计划——蓝色监狱。300名高中生前锋被聚集在一起，在残酷的淘汰赛中争夺唯一的生存名额。',
    director: '渡边彻明',
    actors: ['浦和希', '海渡翼', '小野友树', '齐藤壮马'],
    region: '日本',
    duration: '24集',
    updateDate: '2024-07-22',
    coverImage: 'https://readdy.ai/api/search-image?query=Intense%20soccer%20anime%20scene%20with%20dynamic%20action%2C%20players%20on%20futuristic%20training%20field%2C%20dramatic%20sports%20action%2C%20blue%20energy%20effects%2C%20anime%20style%2C%20competitive%20atmosphere&width=800&height=450&seq=movie-cover-13&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Japanese%20sports%20anime%20poster%2C%20soccer%20player%20in%20dynamic%20action%20pose%2C%20blue%20energy%20aura%2C%20futuristic%20training%20facility%20background%2C%20intense%20competitive%20design&width=600&height=800&seq=movie-poster-13&orientation=portrait',
    isHot: false,
    isNew: true,
    tags: ['新番', '运动', '热血'],
  },
  {
    id: '14',
    title: '飞驰人生2',
    subtitle: 'Pegasus 2',
    category: 'movie',
    genres: ['喜剧', '运动', '剧情'],
    year: 2024,
    rating: 8.3,
    description: '曾经的赛车冠军张驰在经历了人生的低谷后，决定重返赛车场。这一次，他不仅要面对更年轻、更强大的对手，还要克服年龄和身体带来的巨大挑战。一场关于梦想与坚持的爆笑热血之旅。',
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正', '张本煜'],
    region: '中国大陆',
    duration: '129分钟',
    updateDate: '2024-06-15',
    coverImage: 'https://readdy.ai/api/search-image?query=Racing%20car%20on%20dusty%20desert%20track%20at%20high%20speed%2C%20dramatic%20action%20shot%2C%20golden%20sunset%20lighting%2C%20dust%20trail%2C%20intense%20motion%20blur%2C%20cinematic%20composition&width=800&height=450&seq=movie-cover-14&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20racing%20movie%20poster%2C%20racing%20car%20with%20comedic%20characters%2C%20desert%20background%2C%20action%20and%20humor%20mix%2C%20warm%20golden%20tones%2C%20cinematic%20poster&width=600&height=800&seq=movie-poster-14&orientation=portrait',
    isHot: false,
    isNew: false,
    tags: ['喜剧', '赛车', '励志'],
  },
  {
    id: '15',
    title: '舌尖上的中国第四季',
    subtitle: 'A Bite of China S4',
    category: 'documentary',
    genres: ['纪录片', '美食', '文化'],
    year: 2024,
    rating: 9.5,
    description: '时隔多年，经典美食纪录片《舌尖上的中国》第四季重磅回归。全新视角探寻中国人餐桌上的故事，从山川湖海到市井小巷，用镜头记录最真实、最动人的中国味道与文化传承。',
    director: '陈晓卿',
    actors: ['李立宏'],
    region: '中国大陆',
    duration: '8集',
    updateDate: '2024-07-18',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20food%20documentary%20scene%2C%20steaming%20hot%20traditional%20Chinese%20dishes%20on%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20rich%20colors%2C%20authentic%20cooking%20atmosphere%2C%20food%20photography&width=800&height=450&seq=movie-cover-15&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%2C%20beautiful%20traditional%20Chinese%20cuisine%20display%2C%20warm%20and%20inviting%20atmosphere%2C%20rich%20colors%20and%20textures%2C%20elegant%20food%20photography%20style&width=600&height=800&seq=movie-poster-15&orientation=portrait',
    isHot: true,
    isNew: true,
    tags: ['热播', '纪录片', '美食'],
  },
  {
    id: '16',
    title: '乘风破浪的姐姐第五季',
    subtitle: 'Sisters Who Make Waves S5',
    category: 'variety',
    genres: ['综艺', '音乐', '竞演'],
    year: 2024,
    rating: 8.5,
    description: '全新一季乘风破浪，30+姐姐再次集结！她们将在这个舞台上突破年龄的限制，挑战全新的自我，用实力证明女性的无限可能。每一次公演都是一次蜕变，每一首歌都是一次宣告。',
    director: '晏吉',
    actors: ['陈丽君', '戚薇', '刘忻', '陈昊宇'],
    region: '中国大陆',
    duration: '12期',
    updateDate: '2024-07-27',
    coverImage: 'https://readdy.ai/api/search-image?query=Grand%20stage%20performance%20with%20group%20of%20female%20performers%20in%20sparkling%20outfits%2C%20dramatic%20stage%20lighting%2C%20dance%20performance%2C%20empowering%20atmosphere%2C%20colorful%20light%20show&width=800&height=450&seq=movie-cover-16&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20female%20group%20performance%20show%20poster%2C%20elegant%20women%20in%20stunning%20gowns%2C%20stage%20spotlight%2C%20glamorous%20and%20powerful%20design%2C%20golden%20and%20pink%20tones&width=600&height=800&seq=movie-poster-16&orientation=portrait',
    isHot: true,
    isNew: false,
    tags: ['热播', '综艺', '女性'],
  },
];

export const getMoviesByCategory = (category: string) => {
  return movies.filter((m) => m.category === category);
};

export const getHotMovies = () => {
  return movies.filter((m) => m.isHot);
};

export const getNewMovies = () => {
  return movies.filter((m) => m.isNew);
};

export const getMovieById = (id: string) => {
  return movies.find((m) => m.id === id);
};

export const getRelatedMovies = (movie: Movie, limit: number = 4) => {
  return movies
    .filter((m) => m.id !== movie.id && m.category === movie.category)
    .slice(0, limit);
};

export const getCategoryName = (slug: string) => {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
};